import React, { useState, useEffect } from 'react';
import TileGroup from './TileGroup';
import SingleSite from './SingleSite';
import DropdownFilter from '../Administration/Filters/DropdownFilter';

const MyCharges = ({ charges }) => {

    const [filters, setFilters] = useState({});
    const [statusesToDisplay, setStatusesToDisplay] = useState([]);

    const chargesStatuses = [
        {
            id: 1,
            status: 'Active',
            label: 'Active'
        },
        {
            id: 2,
            status: 'Expired',
            label: 'Expired'
        },
        {
            id: 3,
            status: 'Disabled',
            label: 'Disabled'
        },
        {
            id: 4,
            status: 'Deleted',
            label: 'Deleted'
        },
        {
            id: 5,
            status: 'Archived',
            label: 'Archived'
        }
    ]

    const statusFilterOptions = chargesStatuses.map(x=>
        {
            return {
                key: x.status,
                value: x.label
            }
        }
    )

    useEffect(() => {
        return updateResults();
    }, [filters])

    const updateResults = () => {
        setStatusesToDisplay(filters.siteStatus ? chargesStatuses.filter(x => filters.siteStatus.split(",").includes(x.status)) : chargesStatuses);
    }

    const handleNoSelection = () => {
        setStatusesToDisplay([])
    }

    const _onFilterChange = (fieldName, value) => {
                setFilters({
            ...filters,
            [fieldName]: value
        });
    }

    return(
        <div>
            <div className="cell">
                <DropdownFilter 
                    fieldName='siteStatus'
                    title='Site Status'
                    onChange = {_onFilterChange}
                    noselection = {handleNoSelection}
                    includeSelectAll = {true}
                    values={statusFilterOptions}
                />
            </div>
            <div>
                {statusesToDisplay.map(x=> 
                    <TileGroup  
                        key={x.id}
                        groupBy={x.label} 
                        elements={charges.filter(charge => (charge.siteStatus === x.status)).map(s =>
                            <SingleSite
                                key={s.id}
                                site={s}
                                isCharge={true}
                            />)}
                    />)}
            </div>
        </div>
    );
}

export default MyCharges


// WEBPACK FOOTER //
// ./src/components/ManageCenter/MyCharges.js